
export { GGUSection } from "/codebuild/output/src3122444883/src/packages/shared-components/src/campaign/GGUSection.tsx"